import { AsyncPipe } from '@angular/common';
import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { PaymentRetryMethod } from '@fitness-force/enum';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Component({
  selector: 'retry-mode',
  templateUrl: './retry-mode.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [TranslateModule, AsyncPipe],
})
export class RetryModeComponent {
  private readonly translate = inject(TranslateService);

  columnData: Observable<any> = new BehaviorSubject(null);
  additionData: Observable<any> = new BehaviorSubject(null);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  getMode(value: number, _data: any) {
    if (!value || value == 0 || value == -1) return '-';
    else if (Object.keys(value).length == 0) {
      return '-';
    } else {
      return this.getLocalizedRetryMethod(value);
    }
  }

  private getLocalizedRetryMethod(value: number): string {
    const enumKey = PaymentRetryMethod[value];
    if (!enumKey) return '-';

    // Map enum keys to translation keys
    const translationKeyMap: { [key: string]: string } = {
      None: 'REPORTS.PAYMENT_RETRY_METHOD.NONE',
      RecurringCharge: 'REPORTS.PAYMENT_RETRY_METHOD.RECURRING_CHARGE',
      AutoRetry: 'REPORTS.PAYMENT_RETRY_METHOD.AUTO_RETRY',
      Manual: 'REPORTS.PAYMENT_RETRY_METHOD.MANUAL',
      OnDemand: 'REPORTS.PAYMENT_RETRY_METHOD.ON_DEMAND',
    };

    const translationKey = translationKeyMap[enumKey];
    if (translationKey) {
      // For now, return a placeholder. In a real implementation, you'd use translate.instant() or similar
      // but since this is used in template binding, we need to handle async translation
      return this.translate.instant(translationKey);
    }

    return enumKey; // Fallback to enum key if no translation found
  }
}
